import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { Component, OnInit, Output, EventEmitter } from "@angular/core";
import { HttpEventType, HttpClient } from "@angular/common/http";
import { FeedBack, LeadSubmit } from "../models/call-center.model";
import { Observable } from "rxjs";
import { PostResponse } from "../models/common-model";
import * as signalR from "@aspnet/signalr";
import { CommonService } from "./common.service";
@Injectable({
  providedIn: "root",
})
export class LeadsService {
  constructor(private http: HttpClient, private commonService: CommonService) {}

  //To Fetch Leads Data
  getAllLeadsAndAppointments(payload: any) {
    return this.http.post<any>(
      environment.apiUrlV2 + "LeadsManagement/FetchAllLeads/",
      payload
    );
  }

  private hubConnectionForCreateUser: signalR.HubConnection;

  startCallConnection() {
    debugger;
    this.hubConnectionForCreateUser = new signalR.HubConnectionBuilder()
      .withUrl(environment.notificationEndpoint + "/InboundCallHub")
      .withAutomaticReconnect()
      .configureLogging(signalR.LogLevel.Information)
      .configureLogging(signalR.LogLevel.Error)
      .configureLogging(signalR.LogLevel.Trace)
      .build();

    this.hubConnectionForCreateUser.on("ShowAddModal", (message: string) => {
      debugger;
      var data1 = null;

      if (data1 !== null || data1 == null) {
        debugger;
        alert(message);
        let data = {
          patientMobileNumber: message,
          agentId: localStorage.getItem("username"),
          crmNumber: "",
          didNumber: "",
        };
        if (localStorage.getItem("CurrentInBoundCallDetails") !== null) {
          data1 = JSON.parse(localStorage.getItem("CurrentInBoundCallDetails"));
        }
        localStorage.setItem("CurrentInBoundCallDetails", JSON.stringify(data));
        this.commonService.openOutPopUp("INBOUND");
      }
    });
    this.hubConnectionForCreateUser
      .start()
      .then(() => {
        this.hubConnectionForCreateUser.serverTimeoutInMilliseconds = 99999000; // 27 Hours
        this.hubConnectionForCreateUser.keepAliveIntervalInMilliseconds = 15000; // 27 Hours
        // this.hubConnection.invoke('getConnectionId')
        //   .then(function (connectionId) {
        //     console.log('Apollo Signalr Hub Connected !: ', connectionId);
        //   })
      })
      .catch((err) => {
        return console.error(err ? err.toString() : "");
      });
  }

  stopCallConnection() {
    this.hubConnectionForCreateUser.stop();
  }

  //To Fetch Optimized Leads Data
  getAllOptimizedLeadsAndAppointmentsData(payload: any) {
    return this.http.post<any>(
      environment.apiUrlV2 + "LeadsManagement/FetchAllLeads",
      payload
    );
  }

  getAllLeadsAndAppointmentsReport(payload: any) {
    return this.http.post<any>(
      environment.apiUrlV2 + "LeadsManagement/FetchAllLeadsReport",
      payload
    );
  }

  getAllLeadsAndAppointmentsOnCallLogId(payload: any) {
    return this.http.post<any>(
      environment.apiUrl +
        "LeadsManagement/FetchLeadInfoOnCallLogId/?leadId=" +
        payload,
      null
    );
  }

  getAllLeadCallDispositionData(leadId) {
    return this.http.get(
      `${environment.apiUrl}LeadsManagement/FetchLeadCallDisposition?leadId=${leadId}`
    );
  }

   getFeedbacks(leadId) {
    return this.http.get(
      `${environment.apiUrl}LeadsManagement/GetAllRemarks?leadId=${leadId}`
    );
  }

 addFeedBack(payload: FeedBack): Observable<PostResponse> {
    return this.http.post<PostResponse>(
      `${environment.apiUrl}LeadsManagement/AddRemarks/`,
      payload
    );
  }

  addCallCenterLead(payload: LeadSubmit): Observable<PostResponse> {
    return this.http.post<PostResponse>(
      `${environment.apiUrl}LeadsManagement/SubmitLead/`,
      payload
    );
  }

  getAllBusinessUnitsForDialerLeads() {
    return this.http.get(`${environment.apiUrl}LookUp/FetchAllBussinessUnits`);
  }

  DownloadSampleDialerUploadFile() {
    return this.http.get(
      `${environment.apiUrl}TataDialer/DownloadSampleDialerUploadFile`,
      { responseType: "text" as "json" }
    );
  }

  GetTataDialerUploads(businessUnitId) {
    return this.http.get(
      `${environment.apiUrl}TataDialer/GetTataDialerUploads/${businessUnitId}`
    );
  }

  UploadDialerLeadsFile(payload) {
    return this.http.post(
      `${environment.apiUrl}TataDialer/UploadDialerLeadsFile`,
      payload,
      { reportProgress: true, observe: "events" }
    );
  }

  UploadScheduleFile(payload: any) {
    debugger;
    return this.http.post(`${environment.apiUrl}Task/TaskUpload`, payload, {
      reportProgress: true,
      observe: "events",
    });
  }

  getSchedulerList(payload: any) {
    return this.http.post(
      `${environment.apiUrl}Task/FetchAllTaskScheduler`,
      payload
    );
  }

  fetchFile() {
    return this.http.get(`${environment.apiUrl}Task/FetchAllTaskCategories`);
  }

  DownloadFile(TATALeadsDownload) {
    return this.http.get(
      `${environment.apiUrl}TataDialer/DownloadFile?awsKey=${TATALeadsDownload}`
    );
  }

  getCallLogs(RowsCount, PageNo, CallType, FromDate, ToDate, didNumber) {
    return this.http.get(
      `${environment.apiUrl}CallCenter/GetCallLogs/?RowsCount=${RowsCount}&PageNo=${PageNo}&CallType=${CallType}&FromDate=${FromDate}&ToDate=${ToDate}&didNumber=${didNumber}`
    );
  }

  getCallHistoryLogs(
    RowsCount,
    PageNo,
    FromDate,
    ToDate,
    didNumber,
    mobileNumber
  ) {
    return this.http.get(
      `${environment.apiUrl}CallCenter/GetCallHistory/?RowsCount=${RowsCount}&PageNo=${PageNo}&FromDate=${FromDate}&ToDate=${ToDate}&didNumber=${didNumber}&mobileNumber=${mobileNumber}`
    );
  }

  getNPSReport(
    RowsCount,
    PageNo,
    FromDate,
    ToDate,
    feedbackId,
    businessUnitName
  ) {
    return this.http.get(
      `${environment.apiUrl}CallCenter/GetFeedbackFormDetails/?RowsCount=${RowsCount}&PageNo=${PageNo}&FromDate=${FromDate}&ToDate=${ToDate}&feedbackId=${feedbackId}&businessUnitName=${businessUnitName}`
    );
  }

  getCallLogsReport(RowsCount, PageNo, CallType, FromDate, ToDate, didNumber) {
    return this.http.get(
      `${environment.apiUrl}CallCenter/GetCallLogs/?RowsCount=${RowsCount}&PageNo=${PageNo}&CallType=${CallType}&FromDate=${FromDate}&ToDate=${ToDate}&didNumber=${didNumber}`
    );
  }

  UpdateInboundCallLogsData(payload) {
    return this.http.post(
      `${environment.apiUrl}CallCenter/UpdateInboundCall`,
      payload
    );
  }

  getconfirmedAppointments(rowsCount, pageNo, fromDate, toDate, clinicTypeId) {
    return this.http.get(
      `${environment.apiUrl}CallCenter/GetConfirmedAppointments/?RowsCount=${rowsCount}&PageNo=${pageNo}&FromDate=${fromDate}&ToDate=${toDate}&ClinicTypeId=${clinicTypeId}`
    );
  }

  getwalkinLeadsData(rowsCount, pageNo, fromDate, toDate, clinicTypeId) {
    return this.http.get(
      `${environment.apiUrl}CallCenter/GetWalkinLeads/?RowsCount=${rowsCount}&PageNo=${pageNo}&FromDate=${fromDate}&ToDate=${toDate}&ClinicTypeId=${clinicTypeId}`
    );
  }

  getTeleConsultationLeadsData(
    rowsCount,
    pageNo,
    fromDate,
    toDate,
    clinicTypeId
  ) {
    return this.http.get(
      `${environment.apiUrl}CallCenter/GetTeleConsultationLeads/?RowsCount=${rowsCount}&PageNo=${pageNo}&FromDate=${fromDate}&ToDate=${toDate}&ClinicTypeId=${clinicTypeId}`
    );
  }

  getHealthCheckAppointments(rowsCount, pageNo, fromDate, toDate) {
    return this.http.get(
      `${environment.apiUrl}HealthCheck/GethealthCheckData/?RowsCount=${rowsCount}&PageNo=${pageNo}&FromDate=${fromDate}&ToDate=${toDate}`
    );
  }

  getCorpHealthCheckAppointments(rowsCount, pageNo, fromDate, toDate) {
    return this.http.get(
      `${environment.apiUrl}CorporateHealthCheck/GetCorphealthCheckData/?RowsCount=${rowsCount}&PageNo=${pageNo}&FromDate=${fromDate}&ToDate=${toDate}`
    );
  }

  getRescheduledLeadsData(rowsCount, pageNo, fromDate, toDate, clinicTypeId) {
    return this.http.get(
      `${environment.apiUrl}CallCenter/GetReschedulingLeads/?RowsCount=${rowsCount}&PageNo=${pageNo}&FromDate=${fromDate}&ToDate=${toDate}&ClinicTypeId=${clinicTypeId}`
    );
  }

  getCallBackLater(rowsCount, pageNo, fromDate, toDate, clinicTypeId) {
    return this.http.get(
      `${environment.apiUrl}CallCenter/GetCallBackLaterLeads/?RowsCount=${rowsCount}&PageNo=${pageNo}&FromDate=${fromDate}&ToDate=${toDate}&ClinicTypeId=${clinicTypeId}`
    );
  }
  getUserLogs(rowsCount, pageNo, businessUnitName, roleId) {
    return this.http.get(
      `${environment.apiUrl}CallCenter/GetUserLogs/?RowsCount=${rowsCount}&PageNo=${pageNo}&businessUnitName=${businessUnitName}&roleId=${roleId}`
    );
  }

  GetCallHistory(callType: string, callDate?: string, mobileno?: string) {
    return this.http.get(
      `${environment.apiUrl}TataDialer/GetHistory?callType=${callType}&callDate=${callDate}&mobileNo=${mobileno}`
    );
  }

  SyncCallData(leadId) {
    return this.http.post(
      `${environment.apiUrl}TataDialer/SyncHistory?val=${leadId}`,
      ""
    );
  }
}
